import { useEffect } from 'react';

export const usePageTitle = (title: string) => {
    useEffect(() => {
        const previousTitle = document.title;
        document.title = title ? `${title} | Portfolio of Haraprosad Biswas` : 'Portfolio of Haraprosad Biswas';

        // Cleanup function to restore previous title if component unmounts
        return () => {
            document.title = previousTitle;
        };
    }, [title]);
}; 